export default __webpack_public_path__ + "static/am-6fc46e8ba9726579e9e26ea2d3cb3084.svg";